import { createSlice } from "@reduxjs/toolkit";

const defaultData = {
  id: 0,
  data: {},
};

export const TransactionSlice = createSlice({
  name: "Transaction",
  initialState: defaultData,
  reducers: {
    setTransaction: (state, action) => {
      for (const [key, value] of Object.entries(action.payload)) {
        // console.log(`${key}: ${value}`);
        // Convert id to Number before storing
        if (key === "id" && value != null) {
          state[key] = Number(value);
        } else {
          state[key] = value;
        }
      }
    },
    resetTransaction: () => defaultData,
  },
});

// Action creators are generated for each case reducer function
export const { setTransaction, resetTransaction } = TransactionSlice.actions;

export default TransactionSlice.reducer;
